import { toast } from "react-toastify";
import { removeVendor, vendorAdded } from "./vendorSlice";
import Repo from "../../Repository/Repo";

export const createVendor = async (values, dispatch) => {
  let { data } = await Repo.vendor({
    request: {
      method: "saveVendor",
      data: {
        ...values,
      },
    },
  });
  if (data.response.data.vendor) {
    toast.configure();
    toast.success("Vendor Added Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    toast.configure();
    toast.error("Vendor not added", {
      position: toast.POSITION.TOP_RIGHT,
    });
    dispatch(removeVendor(values));
  }
};

export const vendorDelete = async (
  companyCode,
  id,
  deleted,
  index,
  dispatch
) => {
  let { data } = await Repo.vendor({
    request: {
      method: "deleteVendor",
      data: {
        company_code: companyCode,
        _id: id,
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    toast.configure();
    toast.success("Deleted Successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
  } else {
    toast.configure();
    toast.error("Vendor Not Deleted", {
      position: toast.POSITION.TOP_RIGHT,
    });
    dispatch(vendorAdded({ ...deleted, index }));
  }
};
